var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"12","fill":"#272727"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"4","width":"16","height":"4","fill":"#E31D1C"}}),_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","y":"8","width":"16","height":"4","fill":"#FFD018"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }